import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'wep-ag-grid-cell-renderer-radio',
    templateUrl: './radio.html',
    host: { 'class' : 'wep-ag-grid-cell-renderer-radio' },
    styleUrls: ['./radio.scss']
})

export class AgGridCellRendererRadioComponent implements ICellRendererAngularComp {
    public params: any;
    public radioName:string;

    public agInit(params: any) : void {
        this.params = params;
        this.radioName = this.params.api.context.contextParams.seed.eGridDiv.id;
    }

    public onClick() : void {
        this.params.node.setSelected(true, true);
    }

    public refresh() : boolean {
        return false;
    }
}